/* Laila and Me — PDP custom behaviour */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initVariantSelector();
    initSubscriptionToggle();
    initSellingPlanGuard();
    initCartAddPlanInjector();
    initQuantity();
    initFAQ();
    initStickyATC();
    initGalleryThumbs();
    initGalleryZoom();
  });

  /* Variant selector */
  function initVariantSelector() {
    const pills = document.querySelectorAll('.lm-pdp .lm-variant-pill');
    const variantInput = document.querySelector('.lm-pdp [name="id"]');
    const priceEl = document.querySelector('.lm-pdp .lm-price');
    const atcBtn = document.querySelector('.lm-pdp .lm-btn-primary');
    const stickyAtc = document.querySelector('.lm-pdp-sticky-atc__btn');

    if (!pills.length) return;

    pills.forEach(pill => {
      pill.addEventListener('click', function() {
        if (pill.classList.contains('is-sold-out')) return;

        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');

        const variantId = pill.dataset.variantId;
        const price = pill.dataset.variantPrice;
        const priceFormatted = pill.dataset.variantPriceFormatted;
        const comparePrice = parseFloat(pill.dataset.variantCompare) || 0;
        const compareFormatted = pill.dataset.variantCompareFormatted;
        const available = pill.dataset.variantAvailable === 'true';

        if (variantInput) variantInput.value = variantId;
        if (priceEl && priceFormatted) priceEl.textContent = priceFormatted;

        // Show this variant's OWN strikethrough "original" (compare-at) price.
        // Only show it when the compare price is higher than the sale price,
        // otherwise hide it so we never display another size's original price.
        const compareEl = document.querySelector('.lm-pdp .lm-price-compare');
        if (compareEl) {
          if (comparePrice > parseFloat(price)) {
            compareEl.textContent = compareFormatted;
            compareEl.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
          }
        }
        // Update Afterpay messaging widget with new variant price
        const afterpayEl = document.querySelector('.lm-pdp afterpay-placement');
        if (afterpayEl) {
          const priceDecimal = (parseFloat(price) / 100).toFixed(2);
          afterpayEl.setAttribute('data-amount', priceDecimal);
          // Force the widget to re-render
          if (window.AfterPay && typeof window.AfterPay.attachWidget === 'function') {
            window.AfterPay.attachWidget(afterpayEl);
          }
        }
        if (atcBtn) {
          // Out-of-stock wording is set in Liquid and read from
          // data-lm-soldout-label, so christmas-2026 products keep
          // "Launching 6th October" and everything else falls back to
          // "Coming soon". Prevents variant switching from overwriting the copy.
          const isPreorder = atcBtn.hasAttribute('data-lm-preorder-atc');
          const soldOutLabel = atcBtn.getAttribute('data-lm-soldout-label') || 'Coming soon';
          if (available) {
            atcBtn.disabled = false;
            atcBtn.innerHTML = 'Add to cart · ' + priceFormatted;
          } else {
            atcBtn.disabled = true;
            atcBtn.innerHTML = soldOutLabel;
          }
          const stickyBtn = document.querySelector('.lm-pdp-sticky-atc__btn');
          if (stickyBtn) {
            stickyBtn.disabled = !available;
            if (!available) {
              stickyBtn.textContent = soldOutLabel.toUpperCase();
            } else {
              stickyBtn.textContent = isPreorder ? 'PRE-ORDER' : 'ADD TO CART';
            }
          }
        }
        if (stickyAtc) stickyAtc.dataset.variantId = variantId;

        // Update subscription pricing if subscription is active
        updateSubscriptionPricing();

        // Re-apply correct display price (handles case where Subscribe & Save is active)
        updateDisplayedPrice();

        // Tell Appstle the variant changed
        document.dispatchEvent(new CustomEvent('lm:variant-change', { detail: { variantId: variantId } }));
      });
    });
  }

  /* Subscription module */
  /* Subscription module */
  function initSubscriptionToggle() {
    const options = document.querySelectorAll('.lm-pdp .lm-sub-option');
    const frequency = document.querySelector('.lm-pdp .lm-sub-frequency');
    const sellingPlanInput = document.querySelector('.lm-pdp [name="selling_plan"]');

    if (!options.length) return;

    // Cache the initial base price on the buy-box so single-variant products
    // (no .lm-variant-pill) still have a price reference for updateDisplayedPrice().
    const buyBox = document.querySelector('.lm-pdp .lm-buy-box');
    if (buyBox && !buyBox.dataset.basePrice) {
      const initialPriceEl = document.querySelector('.lm-pdp .lm-price');
      if (initialPriceEl) {
        const cents = parsePriceToCents(initialPriceEl.textContent);
        if (cents !== null) buyBox.dataset.basePrice = String(cents);
      }
    }

    options.forEach(opt => {
      opt.addEventListener('click', function() {
        options.forEach(o => {
          o.classList.remove('is-active');
          o.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('is-active');
        opt.setAttribute('aria-checked', 'true');

        const planId = opt.dataset.sellingPlanId || '';
        if (sellingPlanInput) sellingPlanInput.value = planId;

        if (planId && frequency) {
          frequency.classList.add('is-visible');
        } else if (frequency) {
          frequency.classList.remove('is-visible');
        }

        // Bulk sizes are one-time only — hide/show them for the chosen purchase type.
        // planId is truthy only for the Subscribe & Save option.
        applyBulkVisibility(!!planId);

        // Update main price, ATC button, Afterpay, and sticky mobile price
        updateDisplayedPrice();
      });
    });

        // Set correct bulk visibility for whichever option is active on load.
    const initiallyActive = document.querySelector('.lm-pdp .lm-sub-option.is-active');
    applyBulkVisibility(!!(initiallyActive && initiallyActive.dataset.sellingPlanId));

    // Same for Afterpay — covers products where Subscribe is pre-selected on load.
    syncAfterpayVisibility();

    /* ── Delivery frequency pills ─────────────────────────────────────────────
       Replaces the old <select>, which was rendered disabled + form="" (so it
       never submitted) and, once this function enabled it, duplicated the hidden
       input's name="selling_plan" — posting the field twice and letting a
       One-time buyer carry a plan ID to the cart.

       The hidden input is now the only selling_plan field on the form. These
       pills write into it and then force a full reprice, which is what the old
       handler never did. */
    const freqPills = document.querySelectorAll('.lm-pdp .lm-freq-pill');
    const freqSummary = document.querySelector('.lm-pdp [data-lm-freq-summary]');

    freqPills.forEach(pill => {
      pill.addEventListener('click', function () {
        freqPills.forEach(p => {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');

        // The Subscribe option is the only one carrying data-sub-price. It stays
        // the single object the price resolvers read a plan ID from.
        const subOpt = document.querySelector('.lm-pdp .lm-sub-option[data-sub-price]');
        if (subOpt) {
          subOpt.dataset.sellingPlanId = pill.dataset.planId;
          if (pill.dataset.discount) subOpt.dataset.discount = pill.dataset.discount;

          // Only push to the form if Subscribe is the active purchase type —
          // otherwise a One-time buyer inherits a plan ID.
          if (sellingPlanInput && subOpt.classList.contains('is-active')) {
            sellingPlanInput.value = pill.dataset.planId;
          }

          // Rewrite the saving if this cadence discounts differently.
          const pct = Math.round(parseFloat(pill.dataset.discount) || 0);
          subOpt.querySelectorAll('[data-lm-sub-pct]').forEach(el => {
            el.textContent = String(pct);
          });
        }

        // Visible confirmation — the thing that was missing entirely.
        if (freqSummary) {
          const nameEl = pill.querySelector('.lm-freq-name');
          if (nameEl) freqSummary.textContent = 'Delivered every ' + nameEl.textContent.trim();
        }

        updateSubscriptionPricing();
        updateVariantPillPrices();
        updateDisplayedPrice();
      });
    });

    // Sync pill prices to whichever purchase type is active on load.
    updateVariantPillPrices();
  }

  /* ── Selling plan guard ─────────────────────────────────────────────────────
     The pills set the hidden selling_plan input correctly, but the value was
     still not reaching the cart. Two things break it between click and POST,
     and neither is visible from the PDP:

       1. A SECOND [name="selling_plan"] field in the same form. Subscription
          apps (Appstle) inject their own hidden input into any form that posts
          to /cart/add. When two fields share a name the serialiser keeps the
          last one — theirs, which is empty — so the line item is added as a
          one-time purchase at full price.
       2. Timing. The theme and the cart-drawer app bind their own submit
          handlers. Anything injected after DOMContentLoaded is invisible to a
          reference cached at init.

     This resolves the plan from the LIVE DOM at the moment of submission and
     collapses every selling_plan field down to the one we control. Registered
     in the CAPTURE phase so it runs before the theme's and the app's handlers,
     which bind in the bubble phase. */
  function initSellingPlanGuard() {
    const form = document.querySelector('.lm-pdp form.lm-product-form') ||
                 document.querySelector('.lm-pdp form[action*="/cart/add"]');
    if (!form) return;

    function syncSellingPlan() {
      const activeOpt  = document.querySelector('.lm-pdp .lm-sub-option.is-active');
      const activeFreq = document.querySelector('.lm-pdp .lm-freq-pill.is-active');

      // A plan only applies when Subscribe is the active purchase type. The
      // frequency pill wins over the option's default when one is selected.
      let planId = '';
      if (activeOpt && activeOpt.dataset.sellingPlanId) {
        planId = (activeFreq && activeFreq.dataset.planId)
          ? activeFreq.dataset.planId
          : activeOpt.dataset.sellingPlanId;
      }

      // Ours is tagged in main-product-custom.liquid. Recreated if a theme
      // re-render has dropped it.
      let ours = form.querySelector('[data-lm-selling-plan]');
      if (!ours) {
        ours = document.createElement('input');
        ours.type = 'hidden';
        ours.name = 'selling_plan';
        ours.setAttribute('data-lm-selling-plan', '');
        form.appendChild(ours);
      }

      // Anything else claiming the name is neutralised. Disabled fields are
      // skipped by FormData and by jQuery.serialize(), so only ours posts.
      form.querySelectorAll('[name="selling_plan"]').forEach(function (f) {
        if (f !== ours) {
          f.disabled = true;
          f.setAttribute('data-lm-superseded', '');
        }
      });

      // One-time purchase: omit the field entirely rather than posting an empty
      // string, which some cart endpoints treat as a malformed plan reference.
      ours.value = planId;
      ours.disabled = !planId;

      return planId;
    }

    // The theme submits the form; some drawer apps intercept the button click
    // instead and never fire submit. Both paths are covered, in capture phase.
    form.addEventListener('submit', syncSellingPlan, true);
    document.addEventListener('submit', syncSellingPlan, true);

    const atc = form.querySelector('.lm-btn-primary');
    if (atc) atc.addEventListener('click', syncSellingPlan, true);

    const stickyBtn = document.querySelector('.lm-pdp-sticky-atc__btn');
    if (stickyBtn) stickyBtn.addEventListener('click', syncSellingPlan, true);

    // Keep the form correct while the customer is still choosing, so any app
    // reading the form mid-session sees the right plan.
    document.querySelectorAll('.lm-pdp .lm-sub-option, .lm-pdp .lm-freq-pill')
      .forEach(function (el) { el.addEventListener('click', syncSellingPlan); });

    // Correct on load, before any interaction.
    syncSellingPlan();
  }
/* ── Cart-add plan injector ─────────────────────────────────────────────────
     Aug 2026. The form-level guard keeps a correct selling_plan input, but
     UpCart intercepts add-to-cart and constructs its own request, so the field
     never reaches /cart/add. Result: the item lands as a one-time purchase at
     full price, and the customer has to re-subscribe in the drawer — where
     Appstle applies its FIRST plan (Every 14 days), silently discarding the
     frequency they picked on the PDP.

     This patches fetch and XHR so the plan is injected into the request body
     regardless of which script built it.

     SAFETY: only injects when (a) Subscribe is the active purchase type, and
     (b) the payload's variant id matches the variant currently selected on the
     PDP. Without the id check, an UpCart upsell adding a different product
     would inherit this product's selling plan. */
  function initCartAddPlanInjector() {
    if (window.__lmCartAddPlanInjector) return;
    window.__lmCartAddPlanInjector = true;
    if (!document.querySelector('.lm-pdp')) return;

    function currentPlanId() {
      const opt  = document.querySelector('.lm-pdp .lm-sub-option.is-active');
      const freq = document.querySelector('.lm-pdp .lm-freq-pill.is-active');
      if (!opt || !opt.dataset.sellingPlanId) return '';
      return (freq && freq.dataset.planId) ? freq.dataset.planId : opt.dataset.sellingPlanId;
    }

    function currentVariantId() {
      const f = document.querySelector('.lm-pdp form.lm-product-form [name="id"]') ||
                document.querySelector('.lm-pdp form[action*="/cart/add"] [name="id"]');
      return f ? String(f.value) : '';
    }

    function isCartAdd(url) {
      try { return String(url).indexOf('/cart/add') !== -1; } catch (e) { return false; }
    }

    function idMatches(candidate) {
      const want = currentVariantId();
      return want !== '' && String(candidate) === want;
    }

    /* Returns a modified body, or the original if nothing should change. */
    function inject(body, plan) {
      if (!body || !plan) return body;

      // FormData
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (!idMatches(body.get('id'))) return body;
        if (!body.get('selling_plan')) body.set('selling_plan', plan);
        return body;
      }

      // URLSearchParams
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        if (!idMatches(body.get('id'))) return body;
        if (!body.get('selling_plan')) body.set('selling_plan', plan);
        return body;
      }

      // String — either JSON or urlencoded
      if (typeof body === 'string') {
        const trimmed = body.trim();

        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          try {
            const parsed = JSON.parse(trimmed);

            // { items: [ {id, quantity}, ... ] }
            if (parsed && Array.isArray(parsed.items)) {
              let touched = false;
              parsed.items.forEach(function (item) {
                if (item && idMatches(item.id) && !item.selling_plan) {
                  item.selling_plan = plan;
                  touched = true;
                }
              });
              return touched ? JSON.stringify(parsed) : body;
            }

            // { id, quantity }
            if (parsed && idMatches(parsed.id) && !parsed.selling_plan) {
              parsed.selling_plan = plan;
              return JSON.stringify(parsed);
            }
            return body;
          } catch (e) {
            return body;
          }
        }

        try {
          const params = new URLSearchParams(trimmed);
          if (!idMatches(params.get('id'))) return body;
          if (params.get('selling_plan')) return body;
          params.set('selling_plan', plan);
          return params.toString();
        } catch (e) {
          return body;
        }
      }

      return body;
    }

    /* ── fetch ── */
    if (window.fetch) {
      const origFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          const url = (typeof input === 'string') ? input : (input && input.url);
          if (isCartAdd(url) && init && init.body) {
            const plan = currentPlanId();
            if (plan) init.body = inject(init.body, plan);
          }
        } catch (e) { /* never block the request */ }
        return origFetch.apply(this, arguments);
      };
    }

    /* ── XMLHttpRequest ── */
    if (window.XMLHttpRequest) {
      const origOpen = XMLHttpRequest.prototype.open;
      const origSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__lmUrl = url;
        return origOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function (body) {
        try {
          if (isCartAdd(this.__lmUrl) && body) {
            const plan = currentPlanId();
            if (plan) {
              const patched = inject(body, plan);
              if (patched !== body) return origSend.call(this, patched);
            }
          }
        } catch (e) { /* never block the request */ }
        return origSend.apply(this, arguments);
      };
    }
  }
  /* Bulk sizes are one-time-purchase only. When Subscribe & Save is active we hide
     every pill flagged data-is-bulk="true"; when One-time is active we show them
     again. If the currently selected size gets hidden, we auto-select the first
     still-visible, in-stock size so the form can never submit a bulk variant with a
     subscription selling plan. Universal across all products. */
  function applyBulkVisibility(isSubscription) {
    const pills = document.querySelectorAll('.lm-pdp .lm-variant-pill');
    if (!pills.length) return;

    let activeGotHidden = false;

    pills.forEach(pill => {
      const isBulk = pill.dataset.isBulk === 'true';
      if (isBulk && isSubscription) {
        pill.classList.add('lm-variant-pill--sub-hidden');
        pill.setAttribute('aria-hidden', 'true');
        pill.tabIndex = -1;
        if (pill.classList.contains('is-active')) activeGotHidden = true;
      } else {
        pill.classList.remove('lm-variant-pill--sub-hidden');
        pill.removeAttribute('aria-hidden');
        pill.removeAttribute('tabindex');
      }
    });

    // The selected size was just hidden — fall back to the first visible, in-stock size.
    if (activeGotHidden) {
      const fallback = Array.from(pills).find(function(p) {
        return !p.classList.contains('lm-variant-pill--sub-hidden') &&
               !p.classList.contains('is-sold-out');
      });
      if (fallback) fallback.click();
    }
  }

  /* Update ALL sub options (one-time + subscribe) when variant changes.
     Previously only sub options with [data-discount] were updated, leaving the
     "One-time purchase" line stale after a size swap.

     Prices now come from Shopify's own selling plan allocation via data
     attributes, never from a locally computed percentage — the old inline
     maths here disagreed with the Liquid-rendered figure by a cent. Takes no
     argument; it resolves the active variant itself. */
  function updateSubscriptionPricing() {
    const subOptions = document.querySelectorAll('.lm-pdp .lm-sub-option');
    subOptions.forEach(opt => {
      const priceEl = opt.querySelector('.lm-sub-meta-price');
      if (!priceEl) return;
      const cents = getSubPriceForOption(opt);
      if (cents === null) return;
      priceEl.textContent = formatCentsToPrice(cents);
    });
  }

 /* Keep the price printed on every size pill in sync with the active purchase type.
     One-time  -> the Liquid-rendered original (data-variant-price-formatted)
     Subscribe -> that price minus the active plan's discount %
     The SAVE % badge is deliberately NOT touched: the subscription discount applies
     evenly to every size, so each size's saving vs the base size is unchanged. */
  function updateVariantPillPrices() {
    const pills = document.querySelectorAll('.lm-pdp .lm-variant-pill');
    if (!pills.length) return;

    const activeSubOption = document.querySelector('.lm-pdp .lm-sub-option.is-active');
    let discountPct = 0;
    if (activeSubOption && activeSubOption.dataset.discount) {
      discountPct = parseFloat(activeSubOption.dataset.discount) || 0;
    }

    pills.forEach(pill => {
      const metaEl = pill.querySelector('.lm-variant-meta');
      if (!metaEl) return;

      const baseCents = parseFloat(pill.dataset.variantPrice);
      if (isNaN(baseCents)) return;

      if (discountPct > 0) {
        // 1. This pill's allocation for the ACTIVE plan (correct at any cadence)
        // 2. the default-plan allocation, 3. computed. In that order.
        let subCents = null;
        const activePlanId = activeSubOption && activeSubOption.dataset.sellingPlanId;
        if (activePlanId && pill.dataset.planPrices) {
          try {
            const v = JSON.parse(pill.dataset.planPrices)[String(activePlanId)];
            if (typeof v === 'number' && v > 0) subCents = v;
          } catch (e) { /* malformed map — fall through */ }
        }
        if (subCents === null) {
          const pillSub = parseFloat(pill.dataset.variantSubPrice);
          subCents = (!isNaN(pillSub) && pillSub > 0)
            ? pillSub
            : Math.round(baseCents * (1 - discountPct / 100));
        }
        metaEl.textContent = formatCentsToPrice(subCents);
        metaEl.classList.add('lm-variant-meta--sub');
      } else {
        metaEl.textContent = pill.dataset.variantPriceFormatted || formatCentsToPrice(baseCents);
        metaEl.classList.remove('lm-variant-meta--sub');
      }
    });
  }

  /* Parse "$21.99" -> 2199 (cents). Returns null if not parseable. */
  function parsePriceToCents(text) {
    if (!text) return null;
    const cleaned = String(text).replace(/[^0-9.]/g, '');
    const dollars = parseFloat(cleaned);
    if (isNaN(dollars)) return null;
    return Math.round(dollars * 100);
  }

  /* Format cents -> "$X.XX". Cents are rounded to a whole cent FIRST so a
     fractional input (e.g. 1979.1) can never surface a floating-point artefact
     through toFixed(). */
  function formatCentsToPrice(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  /* Single source of truth for the currently selected variant's base price (cents).
     Multi-variant products: read from the active pill (always fresh).
     Single-variant products: fall back to the cached value on .lm-buy-box. */
  function getActiveBasePriceCents() {
    const activePill = document.querySelector('.lm-pdp .lm-variant-pill.is-active');
    if (activePill && activePill.dataset.variantPrice) {
      const v = parseFloat(activePill.dataset.variantPrice);
      if (!isNaN(v)) return v;
    }
    const buyBox = document.querySelector('.lm-pdp .lm-buy-box');
    if (buyBox && buyBox.dataset.basePrice) {
      const v = parseFloat(buyBox.dataset.basePrice);
      if (!isNaN(v)) return v;
    }
    return null;
  }

  /* Resolve the price a given purchase-type option should display for the
     currently active variant. Source of truth, in order:
       1. data-variant-sub-price on the active size pill  (Shopify allocation)
       2. data-sub-price on the Subscribe button          (single-variant products)
       3. base x (1 - discount%), rounded                 (last-resort fallback)
     This ordering is what guarantees the option price, the ATC button, the size
     pill and the cart all print the identical figure. */
  /* Price (cents) of a given selling plan for the currently active variant,
     read straight from Shopify's allocation map rendered onto the size pill by
     main-product-custom.liquid. Returns null when the map is absent or has no
     entry for that plan, so callers can fall through to the old resolvers. */
  function getPlanPriceCents(planId) {
    if (!planId) return null;
    const activePill = document.querySelector('.lm-pdp .lm-variant-pill.is-active');
    if (!activePill || !activePill.dataset.planPrices) return null;
    try {
      const map = JSON.parse(activePill.dataset.planPrices);
      const v = map[String(planId)];
      return (typeof v === 'number' && v > 0) ? v : null;
    } catch (e) {
      return null;
    }
  }

  function getSubPriceForOption(opt) {
    const baseCents = getActiveBasePriceCents();
    if (baseCents === null) return null;

    // One-time purchase — no plan, no discount.
    if (!opt.dataset.sellingPlanId) return baseCents;

    // Honour whichever cadence is selected, not just the Liquid-rendered default.
    // Falls through to the original resolvers when no allocation exists.
    const planPrice = getPlanPriceCents(opt.dataset.sellingPlanId);
    if (planPrice !== null) return planPrice;

    const activePill = document.querySelector('.lm-pdp .lm-variant-pill.is-active');
    if (activePill) {
      const pillSub = parseFloat(activePill.dataset.variantSubPrice);
      if (!isNaN(pillSub) && pillSub > 0) return pillSub;
    }

    const btnSub = parseFloat(opt.dataset.subPrice);
    if (!isNaN(btnSub) && btnSub > 0) return btnSub;

    const discount = parseFloat(opt.dataset.discount) || 0;
    return Math.round(baseCents * (1 - discount / 100));
  }

  /* Subscription price (cents) for the active variant, or null when the active
     purchase type is One-time. */
  function getActiveSubPriceCents() {
    const activeSubOption = document.querySelector('.lm-pdp .lm-sub-option.is-active');
    if (!activeSubOption || !activeSubOption.dataset.sellingPlanId) return null;
    return getSubPriceForOption(activeSubOption);
  }
  /* Afterpay strip visibility.
     Afterpay is one-time only, so the messaging strip is hidden whenever a
     selling plan is active. Kept as its own function (rather than inlined into
     updateDisplayedPrice) so it can also run once on page load without
     triggering a full reprice. */
  function syncAfterpayVisibility() {
    const strip = document.querySelector('.lm-pdp .lm-afterpay-strip');
    if (!strip) return false;

        const activeSubOption = document.querySelector('.lm-pdp .lm-sub-option.is-active');
    const isSubscription = !!(activeSubOption && activeSubOption.dataset.sellingPlanId);

    strip.classList.toggle('is-hidden', isSubscription);

    // "More payment options" goes with it. Its fallback branch is a hard redirect
    // to /checkout when the native Shopify button isn't in the DOM — which is
    // exactly the state Shopify puts it in for a subscription line item. Left
    // visible, a subscriber who taps it skips the cart entirely.
    const morePayment = document.querySelector('.lm-pdp .lm-more-payment');
    if (morePayment) morePayment.classList.toggle('is-hidden', isSubscription);

    return isSubscription;
  }
  /* Recalculate and apply the displayed price everywhere (main price, ATC,
     Afterpay, mobile sticky ATC) based on active variant + active sub option. */
     
  function updateDisplayedPrice() {
    const basePrice = getActiveBasePriceCents();
    if (basePrice === null) return;

    // Same resolver the Subscribe option uses, so the ATC button and the option
    // line are mathematically incapable of disagreeing.
    const subCents = getActiveSubPriceCents();
    const finalPrice = (subCents !== null) ? subCents : basePrice;
    const finalFormatted = formatCentsToPrice(finalPrice);

    // Keep the sub-option lines in step with the active variant.
    updateSubscriptionPricing();

    // Size pills must show subscription pricing too, otherwise the pill says
    // $21.99 while the buy button says $19.79.
    updateVariantPillPrices();

    // Main price
    const priceEl = document.querySelector('.lm-pdp .lm-price');
    if (priceEl) priceEl.textContent = finalFormatted;

    // ATC button (leave "Sold out" copy intact)
    const atcBtn = document.querySelector('.lm-pdp .lm-btn-primary');
    if (atcBtn && !atcBtn.disabled) {
      atcBtn.innerHTML = 'Add to cart · ' + finalFormatted;
    }

    // Mobile sticky ATC price
    const stickyPriceEl = document.querySelector('.lm-pdp-sticky-atc__price');
    if (stickyPriceEl) stickyPriceEl.textContent = finalFormatted;

        // Afterpay messaging widget (dollars, not cents).
    // Hidden outright on subscription, and we skip the re-attach while hidden —
    // re-rendering a widget inside a display:none parent measures at zero and
    // can come back with a collapsed badge when the customer switches back.
    const afterpayHidden = syncAfterpayVisibility();
    const afterpayEl = document.querySelector('.lm-pdp afterpay-placement');
    if (afterpayEl && !afterpayHidden) {
      afterpayEl.setAttribute('data-amount', (finalPrice / 100).toFixed(2));
      if (window.AfterPay && typeof window.AfterPay.attachWidget === 'function') {
        window.AfterPay.attachWidget(afterpayEl);
      }
    }
  }

  /* Quantity */
  function initQuantity() {
    const qtyInputs = document.querySelectorAll('.lm-pdp .lm-qty input');
    qtyInputs.forEach(input => {
      const wrap = input.closest('.lm-qty');
      if (!wrap) return;
      const minus = wrap.querySelector('[data-qty-minus]');
      const plus = wrap.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        if (v > 1) input.value = v - 1;
      });
      if (plus) plus.addEventListener('click', () => {
        input.value = (parseInt(input.value) || 1) + 1;
      });
    });
  }

  /* FAQ accordion */
  function initFAQ() {
    const triggers = document.querySelectorAll('.lm-pdp .lm-faq-trigger');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const item = trigger.closest('.lm-faq-item');
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', item.classList.contains('is-open'));
      });
    });
  }

  /* Sticky ATC bar */
  function initStickyATC() {
    const sticky = document.querySelector('.lm-pdp-sticky-atc');
    const trigger = document.querySelector('.lm-pdp .lm-btn-primary');
    if (!sticky || !trigger) return;

    let visible = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (shouldShow !== visible) {
          visible = shouldShow;
          sticky.classList.toggle('is-visible', shouldShow);
          document.body.classList.toggle('lm-pdp-sticky-active', shouldShow);
        }
      });
    }, { threshold: 0 });
    observer.observe(trigger);

    const stickyBtn = sticky.querySelector('.lm-pdp-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        const mainAtc = document.querySelector('.lm-pdp .lm-btn-primary');
        if (mainAtc) mainAtc.click();
      });
    }
  }
/* ============================================
     Gallery — swipe track + thumbs + lightbox
     Rebuilt Sep 2026: native scroll-snap track

     Mobile model:
       · Image follows the finger in real time; hold midway
         and it stays midway, release and it settles to the
         nearest image (native scroll-snap, iOS/Android physics)
       · One image per swipe, even on a hard flick
       · Arrows auto-hide after IDLE_MS
       · Tap while arrows hidden  -> wake arrows
       · Tap while arrows visible -> open lightbox
       · Counter updates live while dragging
     Desktop:
       · Thumbs + arrows glide to the image instead of a hard swap
       · Trackpad horizontal swipe also works
     ============================================ */
  function initGalleryThumbs() {
    const thumbs   = document.querySelectorAll('.lm-pdp .lm-thumb');
    const main     = document.querySelector('.lm-pdp .lm-gallery-main');
    const lightbox = document.getElementById('lm-lightbox');
    if (!main) return;

    const track = main.querySelector('.lm-gallery-track');
    if (!track) return;

    const slides = Array.prototype.slice.call(track.querySelectorAll('.lm-gallery-slide'));
    const total  = slides.length;
    if (!total) return;

    /* ── Tunables ───────────────────────────── */
    const IDLE_MS       = 2500;  // arrow auto-hide delay
    const PRELOAD_AHEAD = 2;     // lazy images to warm up ahead of the current one
    /* ───────────────────────────────────────── */

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Lightbox data store (full-size srcs)
    const srcStore = document.querySelector('.lm-lightbox-all-srcs');
    let allSrcs = [];
    let allAlts = [];
    if (srcStore) {
      try {
        allSrcs = JSON.parse(srcStore.dataset.srcs.replace(/'/g, '"'));
        allAlts = JSON.parse(srcStore.dataset.alts.replace(/'/g, '"'));
      } catch (e) {}
    }

    let lightboxIndex = 0;
    let mainIndex     = -1;

    const prevArrow = main.querySelector('.lm-gallery-arrow--prev');
    const nextArrow = main.querySelector('.lm-gallery-arrow--next');
    const counter   = main.querySelector('.lm-gallery-counter');

    const isTouchContext = ('ontouchstart' in window) ||
                           navigator.maxTouchPoints > 0 ||
                           window.matchMedia('(max-width: 768px)').matches;

    /* ── Arrow idle timer ─────────────────────────────────── */
    let idleTimer = null;
    function goIdle() { main.classList.add('is-idle'); }
    function wakeControls() {
      main.classList.remove('is-idle');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(goIdle, IDLE_MS);
    }
    if (isTouchContext && (prevArrow || nextArrow)) {
      idleTimer = setTimeout(goIdle, IDLE_MS);
    }

    /* ── Helpers ──────────────────────────────────────────── */
    function slideWidth() { return track.clientWidth || 1; }
    function clamp(i) { return Math.max(0, Math.min(total - 1, i)); }

    // Updates counter, thumbs, arrows, preloading. Does NOT move the track.
    function setActive(index) {
      if (index === mainIndex) return;
      mainIndex = index;

      slides.forEach(function (s, i) {
        const on = i === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (!on) {
          const v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });

      // Warm up neighbours so the next image is ready before the finger gets there
      for (let i = index - 1; i <= index + PRELOAD_AHEAD; i++) {
        const s = slides[i];
        if (!s) continue;
        const img = s.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      }

      if (counter) counter.textContent = (index + 1) + ' / ' + total;

      thumbs.forEach(function (t) {
        const ti = parseInt(t.dataset.index, 10);
        if (!isNaN(ti)) t.classList.toggle('is-active', ti === index);
      });

      if (prevArrow) prevArrow.disabled = index === 0;
      if (nextArrow) nextArrow.disabled = index === total - 1;
    }

    // Moves the track; setActive fires from the scroll listener as it travels
    function goTo(index, instant) {
      index = clamp(index);
      track.scrollTo({
        left: index * slideWidth(),
        behavior: (instant || reduceMotion) ? 'auto' : 'smooth'
      });
      if (instant) setActive(index);
    }

    /* ── Live tracking while the finger drags ─────────────── */
    let rafId       = null;
    let isScrolling = false;
    let scrollTimer = null;

    track.addEventListener('scroll', function () {
      isScrolling = true;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { isScrolling = false; }, 120);

      if (isTouchContext) wakeControls();

      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        setActive(clamp(Math.round(track.scrollLeft / slideWidth())));
      });
    }, { passive: true });

    /* ── Arrows ───────────────────────────────────────────── */
    if (prevArrow) {
      prevArrow.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(mainIndex - 1);
        wakeControls();
      });
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(mainIndex + 1);
        wakeControls();
      });
    }

    /* ── Thumbs ───────────────────────────────────────────── */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.classList.contains('lm-thumb-more') && lightbox) {
          openLightbox(parseInt(thumb.dataset.index, 10) || 0);
          return;
        }
        const ti = parseInt(thumb.dataset.index, 10);
        if (!isNaN(ti)) goTo(ti);
      });
    });

    /* ── Tap / click on the image ─────────────────────────── */
    track.addEventListener('click', function (e) {
      if (isScrolling) return;                       // a drag, not a tap
      if (e.target.closest('video, iframe')) return; // let video controls work

      if (isTouchContext && main.classList.contains('is-idle')) {
        wakeControls();
        return;
      }
      openLightbox(mainIndex);
    });

    /* ── Keep alignment on rotate / resize ────────────────── */
    let resizeRaf = null;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        track.scrollTo({ left: mainIndex * slideWidth(), behavior: 'auto' });
      });
    });

    // Initial state
    setActive(clamp(Math.round(track.scrollLeft / slideWidth())));

    /* ── Lightbox — swipe track (Sep 2026) ────────────────
       Same drag-to-follow feel as the main gallery. The track
       is built on first open, and full-size images load only
       for the current slide and its neighbours.            */
    let lbTrack       = null;
    let lbSlides      = [];
    let lbRaf         = null;
    let lbScrolling   = false;
    let lbScrollTimer = null;

    const lbPrev    = lightbox ? lightbox.querySelector('.lm-lightbox-prev')    : null;
    const lbNext    = lightbox ? lightbox.querySelector('.lm-lightbox-next')    : null;
    const lbCounter = lightbox ? lightbox.querySelector('.lm-lightbox-counter') : null;

    function lbClamp(i) { return Math.max(0, Math.min(allSrcs.length - 1, i)); }
    function lbWidth()  { return (lbTrack && lbTrack.clientWidth) || 1; }

    function lbLoad(i) {
      const s = lbSlides[i];
      if (!s) return;
      const img = s.querySelector('img');
      if (img && img.dataset.src) {
        img.src = img.dataset.src;
        img.alt = img.dataset.alt || '';
        delete img.dataset.src;
      }
    }

    function lbSetActive(i) {
      lightboxIndex = i;
      lbLoad(i - 1);
      lbLoad(i);
      lbLoad(i + 1);
      if (lbCounter) lbCounter.textContent = (i + 1) + ' / ' + allSrcs.length;
      if (lbPrev) lbPrev.disabled = i === 0;
      if (lbNext) lbNext.disabled = i === allSrcs.length - 1;
    }

    function lbGoTo(i, instant) {
      if (!lbTrack) return;
      i = lbClamp(i);
      lbTrack.scrollTo({
        left: i * lbWidth(),
        behavior: (instant || reduceMotion) ? 'auto' : 'smooth'
      });
      if (instant) lbSetActive(i);
    }

    function buildLightboxTrack() {
      if (lbTrack || !lightbox) return;

      lbTrack = document.createElement('div');
      lbTrack.className = 'lm-lightbox-track';

      allSrcs.forEach(function (src, i) {
        const slide = document.createElement('div');
        slide.className = 'lm-lightbox-slide';
        const img = document.createElement('img');
        img.className   = 'lm-lightbox-img';
        img.draggable   = false;
        img.decoding    = 'async';
        img.dataset.src = src;
        img.dataset.alt = allAlts[i] || '';
        slide.appendChild(img);
        lbTrack.appendChild(slide);
        lbSlides.push(slide);
      });

      // Swap the old single-image wrapper for the track
      const oldWrap = lightbox.querySelector('.lm-lightbox-img-wrap');
      if (oldWrap) {
        oldWrap.parentNode.replaceChild(lbTrack, oldWrap);
      } else {
        lightbox.insertBefore(lbTrack, lbCounter);
      }

      // Live tracking while the finger drags
      lbTrack.addEventListener('scroll', function () {
        lbScrolling = true;
        clearTimeout(lbScrollTimer);
        lbScrollTimer = setTimeout(function () { lbScrolling = false; }, 120);

        if (lbRaf) return;
        lbRaf = requestAnimationFrame(function () {
          lbRaf = null;
          const i = lbClamp(Math.round(lbTrack.scrollLeft / lbWidth()));
          if (i !== lightboxIndex) lbSetActive(i);
        });
      }, { passive: true });

      // Tap the dark area around the image to close (not after a drag)
      lbTrack.addEventListener('click', function (e) {
        if (lbScrolling) return;
        if (e.target.tagName !== 'IMG') closeLightbox();
      });
    }

    function openLightbox(startIndex) {
      if (!lightbox || !allSrcs.length) return;
      buildLightboxTrack();
      lightbox.hidden = false;               // must be visible before measuring
      document.body.style.overflow = 'hidden';
      lbGoTo(startIndex, true);
      lightbox.querySelector('.lm-lightbox-close').focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
      goTo(lightboxIndex, true); // land the main gallery where they left off
    }

    if (lightbox) {
      lightbox.querySelector('.lm-lightbox-close').addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { lbGoTo(lightboxIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbGoTo(lightboxIndex + 1); });

      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape')     closeLightbox();
        if (e.key === 'ArrowRight') lbGoTo(lightboxIndex + 1);
        if (e.key === 'ArrowLeft')  lbGoTo(lightboxIndex - 1);
      });

      // Keep the lightbox aligned on rotate / resize
      window.addEventListener('resize', function () {
        if (lightbox.hidden || !lbTrack) return;
        lbTrack.scrollTo({ left: lightboxIndex * lbWidth(), behavior: 'auto' });
      });
    }
  }

  /* ============================================
     Desktop magnifier zoom
     Targets the ACTIVE slide only (track now holds
     every image). Fine-pointer devices only.
     ============================================ */
  function initGalleryZoom() {
    const main = document.querySelector('.lm-pdp .lm-gallery-main');
    if (!main) return;

    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const ZOOM_SCALE = 2.2;
    main.classList.add('lm-zoomable');
    main.style.setProperty('--lm-zoom-scale', ZOOM_SCALE);

    let raf     = null;
    let pending = null;

    function activeImg() {
      return main.querySelector('.lm-gallery-slide.is-active img');
    }

    function applyOrigin() {
      raf = null;
      if (!pending) return;
      const img = activeImg();
      if (img) img.style.transformOrigin = pending.x + '% ' + pending.y + '%';
    }

    main.addEventListener('mouseenter', function () {
      // Never zoom video media
      if (main.querySelector('.lm-gallery-slide.is-active video, .lm-gallery-slide.is-active iframe')) return;
      main.classList.add('is-zooming');
    });

    main.addEventListener('mousemove', function (e) {
      if (!main.classList.contains('is-zooming')) return;
      const r = main.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width)  * 100;
      const y = ((e.clientY - r.top)  / r.height) * 100;
      pending = {
        x: Math.max(0, Math.min(100, x)),
        y: Math.max(0, Math.min(100, y))
      };
      if (!raf) raf = requestAnimationFrame(applyOrigin);
    });

    main.addEventListener('mouseleave', function () {
      main.classList.remove('is-zooming');
      main.querySelectorAll('.lm-gallery-slide img').forEach(function (img) {
        img.style.transformOrigin = '50% 50%';
      });
    });
  }
})();